import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Reveal, SectionLabel } from "../../lib/motion";
import { FAQS } from "../../data";

export const Faq = () => {
  return (
    <section id="faq" className="py-24 md:py-32 bg-white scroll-mt-20">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <SectionLabel>Frequently Asked</SectionLabel>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
            Questions & answers
          </h2>
          <p className="mt-5 text-warm leading-relaxed">
            Straightforward answers about the property, the HOA, and the path to development.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-warm-border rounded-2xl px-6 bg-white data-[state=open]:bg-warm-light/60 transition-colors"
              >
                <AccordionTrigger className="text-left font-medium text-navy hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-warm leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
